import { controls, grouped } from "../controls";
const salarys = {
    label: "Salarys",
    pageLabel: "Salarys", starting: true, url: "autogen",
    formActions: { edit: { allow: true }, delete: { allow: false } },
    pageType: "history",
    filter: [
        ...controls.displayText({
            tab: "filter", label: "Department",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "Salary-employee-department-department_code", controlType: "Department", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

        ...controls.displayText({
            tab: "filter", label: "Employee",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "Salary-employee-employee_code", controlType: "Employee", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
        ...controls.displayText({
            tab: "filter", label: "EmploymentStatus",
            width: "col-sm-2"
        }),
        ...controls.autoComplete({ tab: "filter", name: "Salary-employee-employment_status-employment_status_code", controlType: "EmploymentStatus", width: "col-sm-2", }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),


        ...controls.magicDateLabel({ tab: "filter", label: "Salary Month", target: "salary_month" }),
        ...controls.magicDate({ tab: "filter", name: "salary_month", dateType: "monthYear", displayFormat: "MMMM yyyy" }),
        ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
        // ...controls.displayText({ tab: "filter", label: "Employment Status" }),
        // ...controls.oc({ tab: "filter", c: "EmploymentStatus", placeHolder: "Employment Status Code", name: "Salary-employee-employment_status-employment_status_code", fastpath: "employment_statues" }),
        // ...controls.showData({ tab: "filter", displaytype: "capital", data: "Salary-employee-employment_status-employment_status_display" }),

    ]
    , form: [
    ]
    , history: {
        perPage: 10,
        reportHeader: "Salarys",
        pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
        clickable: true,
        displayColumns: [
            { Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30 },
            { Header: "Salary Month", accessor: "salary_month", type: 'date' },
            { Header: "Employee Code", accessor: "Salary-employee-employee_code", },
            { Header: "Name as on ID", accessor: "Salary-employee-employee_display", },
            { Header: "Pay Scale", accessor: "Salary-pay_scale-pay_scale_display", },
            { Header: "Salary Bank Name", accessor: "salary_bank_name", },
            { Header: "Salary Ac No", accessor: "salary_ac_no", },
            { Header: "Salary Ifsc Code", accessor: "salary_ifsc_code", },
            { Header: "Fix Pay", accessor: "fix_pay", },
            { Header: "Basic", accessor: "basic", },
            { Header: "Lp", accessor: "leave_pay_amount", },
            { Header: "Wa", accessor: "wada", },
            { Header: "Da", accessor: "da", },
            { Header: "Ca", accessor: "ca", },
            { Header: "Hra", accessor: "hra", },
            { Header: "Grade Pay", accessor: "grade_pay", },
            { Header: "Conveyance", accessor: "conveyance", },
            { Header: "Nps Al", accessor: "nps_al", },
            { Header: "Ot", accessor: "ot", },
            { Header: "Special Other", accessor: "special_other", },
            { Header: "Gp", accessor: "gp", },
            { Header: "Nps Ded 14", accessor: "nps_ded_14", },
            { Header: "Nps Ded 10", accessor: "nps_ded_10", },
            { Header: "Gpf", accessor: "gpf", },
            { Header: "Da Arri", accessor: "da_arri", },
            { Header: "Bank Loan", accessor: "bank_loan", },
            { Header: "Festive Advance", accessor: "festive_advance", },
            { Header: "Pf", accessor: "pf", },
            { Header: "Prof Tax", accessor: "prof_tax", },
            { Header: "Pf Advance", accessor: "pf_advance", },
            { Header: "Mc Loan", accessor: "mc_loan", },
            { Header: "Gis", accessor: "gis", },
            { Header: "Rd", accessor: "rd", },
            { Header: "Lic", accessor: "lic", },
            { Header: "It", accessor: "it", },
            { Header: "house Rent", accessor: "house_rent" },
            { Header: "Other Deductions", accessor: "other_deductions", },
            { Header: "Total Deductions", accessor: "total_deductions", },
            { Header: "Total", accessor: "total", },
            { Header: "Month Days", accessor: "month_days", },
            { Header: "Total Working Days", accessor: "total_working_days", },
            { Header: "Leave Pay Days", accessor: "leave_pay_days", },
            { Header: "Remark", accessor: "remark", },

        ]
    }
};
export default salarys;